import React from 'react';
import { IconSvgProps } from '@models/common';

const Bin: React.FC<IconSvgProps> = (props) => {
  const { size = 18, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      fill='none'>
      <path
        fill='#5C47FA'
        stroke='#5C47FA'
        d='M8.25 2.5h1.5c.406 0 .798.141 1.11.396l.127.117c.329.328.513.773.513 1.237V5.5H15a.25.25 0 0 1 .208.389l-.031.038A.25.25 0 0 1 15 6h-1.25v8.75c0 .406-.141.798-.396 1.11l-.117.127A1.75 1.75 0 0 1 12 16.5H6a1.75 1.75 0 0 1-1.11-.396l-.127-.117a1.75 1.75 0 0 1-.513-1.237V6H3a.25.25 0 0 1-.139-.042l-.038-.031a.25.25 0 0 1-.073-.177l.005-.049a.25.25 0 0 1 .037-.09l.031-.038A.25.25 0 0 1 3 5.5h3.5V4.25c0-.406.141-.798.396-1.11l.117-.127a1.75 1.75 0 0 1 1.064-.504L8.25 2.5Zm-3.5 12.25A1.25 1.25 0 0 0 6 16h6a1.25 1.25 0 0 0 1.25-1.25V6h-8.5v8.75ZM7.5 8.5a.25.25 0 0 1 .139.042l.038.031a.25.25 0 0 1 .073.177v4.5a.25.25 0 0 1-.042.139l-.031.038a.25.25 0 0 1-.316.031l-.038-.031a.25.25 0 0 1-.073-.177v-4.5a.25.25 0 0 1 .042-.139l.031-.038A.25.25 0 0 1 7.5 8.5Zm3 0a.25.25 0 0 1 .139.042l.038.031a.25.25 0 0 1 .073.177v4.5a.25.25 0 0 1-.042.139l-.031.038a.25.25 0 0 1-.316.031l-.038-.031a.25.25 0 0 1-.073-.177v-4.5a.25.25 0 0 1 .042-.139l.031-.038A.25.25 0 0 1 10.5 8.5ZM8.25 3c-.29 0-.57.101-.792.283l-.092.083A1.25 1.25 0 0 0 7 4.25V5.5h4V4.25c0-.29-.101-.57-.283-.792l-.083-.092A1.25 1.25 0 0 0 9.75 3h-1.5Z'
      />
    </svg>
  );
};

export default Bin;
